module.exports = __webpack_public_path__ + "static/media/icons8-npm - Copy.4741eb20.svg";